export default __webpack_public_path__ + "static/media/ic_weather_21.3fd6a13c.svg";